(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ticketrealtime', Ticketrealtime);

    Ticketrealtime.$inject = ['$resource', 'DateUtils'];

    function Ticketrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/ticketrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                        data.fechaproceso = DateUtils.convertDateTimeFromServer(data.fechaproceso);
                        data.fechaenvio = DateUtils.convertDateTimeFromServer(data.fechaenvio);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
